export default __webpack_public_path__ + "static/media/popup-desktop.a111fd64.svg";